const majorFreeRoutes = [
  {
    path: "majorFree",
    redirect: { path: "/majorFree/intro" },
    meta: {
      title: "전공자율선택제",
      titleEn: "Major Free",
    },
    children: [
      {
        path: "intro", // majorFree/intro
        meta: {
          title: "자율전공 소개",
          titleEn: "Intro",
          isDynamic: true,
          menuCd: "MAJOR_FREE_INTRO",
        },
        component: () => import("@/views/majorFree/MajorFreeIntro.vue"),
      },
      {
        path: "roadMap", // majorFree/roadMap
        meta: {
          title: "로드맵",
          titleEn: "Road Map",
          isDynamic: true,
          menuCd: "MAJOR_FREE_ROADMAP",
        },
        component: () => import("@/views/majorFree/MajorFreeRoadMap.vue"),
      },
      {
        path: "education", // majorFree/education
        meta: {
          title: "교육과정",
          titleEn: "Education",
          isDynamic: true,
          menuCd: "MAJOR_FREE_EDUCATION",
        },
        component: () => import("@/views/majorFree/MajorFreeEducation.vue"),
      },
      {
        path: "majorIntro", // majorFree/majorIntro
        meta: {
          title: "전공소개",
          titleEn: "Major Intro",
          isDynamic: true,
          menuCd: "MAJOR_INTRO",
        },
        component: () => import("@/views/majorFree/MajorFreeMajorIntro.vue"),
      },
      {
        path: "counseling", // majorFree/counseling
        meta: {
          title: "전공선택 상담",
          titleEn: "Counseling",
          isDynamic: true,
          menuCd: "MAJOR_COUNSELING",
        },
        component: () => import("@/views/majorFree/MajorFreeCounseling.vue"),
      },
    ],
  },
];
export default majorFreeRoutes;
